import { Injectable, ViewContainerRef, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { EditDistributorDialogComponent } from "./edit-distributor-dialog.component";

@Injectable()
export class EditDistributorDialogService {
  private dialog = inject(MatDialog);

  public open(viewContainerRef: ViewContainerRef, distributor: any) {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "ddd-dialog-backdrop";
    config.disableClose = true;
    config.data = { distributor };
    config.viewContainerRef = viewContainerRef;

    const dialogRef = this.dialog.open(EditDistributorDialogComponent, config);
    return dialogRef.afterClosed();
  }
}
